import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { api } from "@services";
import { PAGINGATION_DEFAULT } from "@share/const";
import { TFactoryManagement } from "./types";

export const initialState: TFactoryManagement.TState = {
    factoryList: {
        data: [],
        ...PAGINGATION_DEFAULT,
    },
    isLoading: false,
    detail: {
        data: {
            id: "",
            name: "",
            symbol: "",
            transportTime: null,
            isActive: true,
        },
    },
    insert: {
        data: {
            id: "",
            name: "",
            symbol: "",
            transportTime: null,
            isActive: true,
        },
    },
    updatingId: '',
    deletingId: ''
};

export const fetchList = createAsyncThunk(
    "fatoryManagement/fetchList",
    async (params: TPagination.SendToServer, { rejectWithValue }) => {
        try {
            const response = await api.factoryAPI.fetchList(params);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const insert = createAsyncThunk(
    "fatoryManagement/insert",
    async (params: TFactoryManagement.FactoryUpsert, { rejectWithValue }) => {
        try {
            const response = await api.factoryAPI.insert(params);
            return response.data
        } catch (error: any) {
            return rejectWithValue(error.response.data)
        }

    }
);

export const update = createAsyncThunk(
    "fatoryManagement/update",
    async (params: TFactoryManagement.FactoryUpsert, { rejectWithValue }) => {
        try {
            const response = await api.factoryAPI.update(params);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    }
);


export const deleteOne = createAsyncThunk(
    "fatoryManagement/deleteOne",
    async (id: string, { rejectWithValue }) => {
        try {
            const response = await api.factoryAPI.delete(id);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    }
);

const factoryListSlice = createSlice({
    name: "factory",
    initialState,
    reducers: {
        setInsertData(state, action) {
            const { key, value } = action.payload;
            const { data } = state.insert;
            data[key] = value;
        },
        setUpdatingData(state, action) {
            const { key, value } = action.payload;
            const { data } = state.detail;
            data[key] = value;
        },
        resetDetail(state, _) {
            state.detail = initialState.detail;
        },
        resetInsert(state, _) {
            state.insert = initialState.insert;
        },
        setUpdatingId(state, action) {
            if (action.payload) {
                const updatingItem = state.factoryList.data.find(x => x.id === action.payload)
                if (updatingItem) {
                    state.detail.data = updatingItem;                  
                }
            } else {
                state.detail = initialState.detail;
            }
            state.updatingId = action.payload;
        },
        setDeletingId(state, action) {
            state.deletingId = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchList.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(
            fetchList.fulfilled,
            (
                state,
                action: PayloadAction<TFactoryManagement.TState["factoryList"]>
            ) => {
                state.factoryList = action.payload;
                state.isLoading = false;
            }
        );
    },
});

export const {
    setInsertData,
    resetDetail,
    setUpdatingId,
    setUpdatingData,
    setDeletingId,
    resetInsert
} = factoryListSlice.actions;

export default factoryListSlice.reducer;
